import { createFileRoute } from '@tanstack/react-router'

import SubmissionDetailPage from '@/components/pages/backoffice/_klb-petani/_petani/submission/_$verificationId/container/DetailSubmissionPage'

export const Route = createFileRoute(
  '/_backoffice/klb-petani/petani/submission/$verificationId/'
)({
  component: SubmissionDetailPage
})
